"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var mediaScreen_1 = require("../../utils/mediaScreen");
exports.Card = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 4px;\n  padding: 2rem;\n  display: grid;\n  grid-auto-flow: row;\n  gap: 1rem;\n\n  ", "\n\n  ", "\n"], ["\n  background: ", ";\n  border-radius: 4px;\n  padding: 2rem;\n  display: grid;\n  grid-auto-flow: row;\n  gap: 1rem;\n\n  ",
    "\n\n  ",
    "\n"])), theme_1.colors.white, mediaScreen_1.mediaScreen({
    device: mediaScreen_1.Device.Tablet,
    style: {
        padding: '1rem',
    },
}), mediaScreen_1.mediaScreen({
    device: mediaScreen_1.Device.Mobile,
    style: {
        padding: '1rem',
    },
}));
var templateObject_1;
//# sourceMappingURL=index.js.map